export default __webpack_public_path__ + "static/media/KoachView Logo with Background.6a01d839.png";